import { mapActions, mapState } from 'vuex';
  
import AppGravarContaDialog from './dialogs/GravarContaDialog.vue';
import AppEditarContaDialog from './dialogs/EditarContaDialog.vue';
import AppGravarVisitaDialog from './dialogs/GravarVisitaDialog.vue';
import AppEditarVisitaDialog from './dialogs/EditarVisitaDialog.vue';
import AppGravarRepresentanteDialog from './dialogs/GravarRepresentanteDialog.vue';
import AppEditarContatoRealizadoDialog from './dialogs/EditarContatoRealizadoDialog.vue';
import AppGravarContatoRealizadoDialog from './dialogs/GravarContatoRealizadoDialog.vue';

import AppUploadArquivoDialog from '../shared/dialogs/UploadArquivoDialog.vue';  
import AppGravarObservacaoDialog from '../shared/dialogs/GravarObservacaoDialog.vue';


import Util from '../util/funcoes.js';
import { ESTADOS, ESTADO_CIVIL, CATEGORIA_CLIENTE } from '../util/constantes.js';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolder, faFile } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFolder,faFile)

export default {
  components: {
    AppEditarContatoRealizadoDialog,  
    AppGravarContatoRealizadoDialog,
    AppGravarContaDialog,
    AppEditarContaDialog,
    AppUploadArquivoDialog,
    AppGravarVisitaDialog,
    AppEditarVisitaDialog,
    AppGravarRepresentanteDialog,
    AppGravarObservacaoDialog,
    FontAwesomeIcon
  },    
  data() {
    return {
      validacao: {
        nome: [
          { required: true },
        ],
        telefone: [
          { required: true },
        ],
      },

      imovel: {
        endereco: "",
        numeroEndereco: "",
        operacao: "",
        bairro: {
          cidade: "",
          nome: "",
          zona: "",
        },
      },
      conta: {
        status: "",
        banco: "",
        tipo: "",
        titular: "",
        agencia: "",
        numeroConta: ""
      },
      perfis: [],
      loadingUsuarios: false,
      loadingCidades: false,
      loadingBairros: false,

      visibilidadeGravarContatoRealizadoDialog: false,
      visibilidadeEditarContatoRealizadoDialog: false,
      visibilidadeGravarContaDialog: false,
      visibilidadeEditarContaDialog: false,
      visibilidadeUploadArquivoDialog: false,
      visibilidadeGravarVisitaDialog: false,
      visibilidadeGravarRepresentanteDialog: false,
      visibilidadeGravarObservacaoDialog: false,
      visibilidadeEditarVisitaDialog: false,

      //Editar Contato
      contatoSelecionado: {},

      contatoRealizado: null,
      horaProximoContato: "",
      dataProximoContato: "",

      contaBancaria: {},
      observacaoSelecionada: {},

      //Editar Visita
      visita: {},
      horaVisita: "",
      dataVisita: "",
      imoveisVisita: {},

      defaultProps: {
        label: 'label',
        children: 'children',
      },
      
      tabSelecionada: "detalhes",
      currentRow: null
    }
  },
  computed: {
    ...mapState('clientesStore', {
      clientes(state) { return state.listaClientes },
      clientePesquisa(state) { return state.clientePesquisa },

      cliente(state) { return state.clienteSelecionado },
      logs(state) { return state.logs },

      usuariosDisponiveis(state) { return state.usuariosDisponiveis },
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_VENDA" })[0] }
    }),      
    clienteNovo() { 
      return this.cliente.id == 0 
    },
    estados() { 
      return ESTADOS;
    },
    estadoCivil() {
      return ESTADO_CIVIL;
    },
    categoriaCliente() {
      return CATEGORIA_CLIENTE;
    },
    disableRadio() {
      return this.cliente.id != 0
    },
    perfisDisponiveis() {
      var auxSetPerfis = new Set();
      var auxSetStatus = new Set();
      var auxArrayPerfis = new Array();
      var auxArrayStatus = new Array();
      var auxPerfis = this.cliente.perfis;
      var auxObjPerfis, auxObjStatus;
      var i, j;
      for (i=0; i < auxPerfis.length; i++) {
        auxSetPerfis.add(this.formatarString(auxPerfis[i].perfil.toString()));
        auxSetStatus.add(this.formatarString(auxPerfis[i].imovel.status.toString()));
      }
      auxSetPerfis.forEach(function(value){
        auxObjPerfis = new Object();
        auxObjPerfis["label"] = " " + value;
        auxObjPerfis["children"] = [];
        auxArrayPerfis.push(auxObjPerfis);
      });
      auxSetStatus.forEach(function(valueStatus){
        auxObjStatus = new Object();
        auxObjStatus["perfil"] = "";
        auxObjStatus["label"] = " " + valueStatus;
        auxObjStatus["children"] = [];
        auxArrayStatus.push(auxObjStatus);
      });
      for(i=0; i < auxArrayStatus.length; i++) {
        for(j=0; j < auxPerfis.length; j++){
          if(" " + this.formatarString(auxPerfis[j].imovel.status.toString()) == auxArrayStatus[i]["label"]){
            auxArrayStatus[i]["children"].push(auxPerfis[j].imovel);
            auxArrayStatus[i]["perfil"] = " " + this.formatarString(auxPerfis[j].perfil.toString());
          }
        }
      }

      for(i=0; i < auxArrayPerfis.length; i++) {
        for(j=0; j < auxArrayStatus.length; j++){
          if((auxArrayPerfis[i]["label"]) == auxArrayStatus[j]["perfil"]){
            auxArrayPerfis[i]["children"].push(auxArrayStatus[j]);
          }
        }
      }
      return auxArrayPerfis;
    },
    //CLIENTE
    exibirCamposPessoaFisica() {
      return this.cliente.personalidadeJuridica == "PESSOA_FISICA";
    },
    exibirCamposPessoaJuridica() {
      return this.cliente.personalidadeJuridica == "PESSOA_JURIDICA";
    },
    exibirBotaoGravarCliente() {
      return (
        (this.permissoes.cadastro && this.cliente.id == 0 && this.tabSelecionada == "detalhes") ||
        (this.permissoes.alteracao && this.cliente.id != 0 && this.tabSelecionada == "detalhes")
      );
    },
    exibirBotaoRemoverCliente(){
      return (
        this.tabSelecionada == "detalhes" && 
        this.cliente.id != 0 &&
        this.permissoes.remocao
      );
    },
    //CONTATOS REALIZADOS
    exibirBotaoNovoContato() {
      return this.tabSelecionada == "contatos"
    },
    exibirBotaoFinalizarContato() { 
      return (
        this.tabSelecionada == "contatos" &&
        this.contatoSelecionado != {} &&
        this.contatoSelecionado.status != "CONCLUIDO"
      );
    },
    //CONTAS BANCÁRIAS
    exibirBotaoNovaConta(){
      return this.tabSelecionada == "contas"
    },
    //VISITAS
    exibirBotaoNovaVisita(){
      return this.tabSelecionada == "visitas"
    },
    //ARQUIVOS
    exibirBotaoUploadArquivo(){
      return this.tabSelecionada == "arquivos"
    },
    dadosPesquisaCliente(){
      return (
        this.clientePesquisa.categoriaPesquisa != "" ||
        this.clientePesquisa.id != "" || 
        this.clientePesquisa.nome != "" || 
        this.clientePesquisa.telefone != "" || 
        this.clientePesquisa.cpfCnpj != ""
        )
    }
  },
  watch: {
    clienteNovo(newValue) {
      if(newValue) {
        this.tabSelecionada = "detalhes"
      }
    },
    'cliente.id': function(newValue, oldValue) {
      if(newValue != oldValue) {
        this.tabSelecionada = "detalhes";
        this.imovel = {
          endereco: "",
          numeroEndereco: "",
          operacao: "",
          bairro: {
            cidade: "",
            nome: "",
            zona: "",
          }
        };
        this.limparContato()
      }         
    }
  },
  created() {
    this.pesquisar();
  },    
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('clientesStore', [
      'novoCliente',
      'limparClientePesquisa',
      'pesquisarClientes',
      'recuperarCliente',
      'gravarCliente',
      'removerCliente',

      'listarUsuarios',

      'gravarContatoRealizado',
      'atualizarContatoRealizado',
      'removerContatoRealizado',
      
      'gravarConta',
      'removerConta',

      'gravarVisita',
      'recuperarVisita',
      'removerVisita',

      'recuperarLogs',

      'removerObservacao'
    ]),
    //PESQUISA
    pesquisar() {
      this.showLoading();
      this.pesquisarClientes(this.clientePesquisa)
      .then((resultado) => {
        switch(resultado.status) {
          case "SUCESSO":
          case "FALHA":
          case "ERRO":
            this.hideLoading();
            break;
        }
      })
    },
    recuperarHandler(cliente) {
      this.recuperar(cliente);
    },
    recuperar(cliente) {
      this.showLoading();

      this.recuperarCliente(cliente)
      .then((resultado) => {
        switch(resultado.status) {
          case "SUCESSO":
          case "FALHA":
          case "ERRO":
            this.hideLoading();
            break;
        }
      })        
    },
    //CADASTRO
    getLabel(array, element) {
      return Util.getLabel(array, element);
    },
    tabClicked(tab) {
      if(tab.name == "logs") {
        let payload = { cliente: { id: this.cliente.id } }
        this.recuperarLogs(payload).catch(() => {
          this.$message.error("Não foi possível recuperar os logs deste cliente");
        });
      }
      if(tab.name != "contatos") {
        this.limparContato()
      }
    },
    //DETALHES - REPRESENTANTE
    exibirGravarRepresentanteDialog() {
      this.visibilidadeGravarRepresentanteDialog = true
    },
    fecharGravarRepresentanteDialog() {
      this.visibilidadeGravarRepresentanteDialog = false;
    },

    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid && this.cliente.personalidadeJuridica == "PESSOA_FISICA") {
          this.gravar();
        } else if(valid && this.cliente.personalidadeJuridica == "PESSOA_JURIDICA" && this.cliente.representantes.length > 0) {
          this.gravar();
        } else {
          if(valid && this.cliente.personalidadeJuridica == "PESSOA_JURIDICA" && this.cliente.representantes.length > 0) {
            this.exibirAlert("Atenção", "Você deve cadastrar ao menos um representante da pessoa jurídica");
          } else {
            this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
          }
        }
      });
    },
    gravar() {
      this.showLoading();
      this.gravarCliente(this.cliente)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    removerClienteHandler() {
      this.$confirm('Deseja realmente remover este cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerCliente(this.cliente)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },

    removerRepresentante(representante) {
      this.cliente.representantes = this.cliente.representantes.filter((elemento) => { return elemento != representante });
    },
    atualizaImovel(data) {
      this.imovel.endereco = data.endereco;
      this.imovel.numeroEndereco = data.numeroEndereco;
      this.imovel.operacao = data.operacao;
      if(data.bairro) { 
        this.imovel.bairro.nome = data.bairro.nome; 
        this.imovel.bairro.cidade = data.bairro.cidade;
        this.imovel.bairro.zona = data.bairro.zona;        
      }
    },
    atualizaConta(row){
      this.conta.status = row.status;
      this.conta.banco = row.banco;
      this.conta.tipo = row.tipo;
      this.conta.titular = row.titular;
      this.conta.agencia = row.agencia;
      this.conta.numeroConta = row.conta;
    },
    //SELECT
    filtrarUsuariosSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload)
      .then(() => {
        this.loadingUsuarios = false;  
      })
    },      
    //CONTATOS REALIZADOS
    atualizaContato(contato) {
      this.contatoSelecionado = contato;
    },
    finalizarContatoRealizado(){
      this.$confirm('Deseja realmente finalizar este contato com o cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let auxContato = {
          status: "CONCLUIDO",
          id: this.contatoSelecionado.id,
          descricao: this.contatoSelecionado.descricao,
          cliente: {
            id: this.cliente.id
          }
        };      
        this.showLoading();
        this.atualizarContatoRealizado(auxContato)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
      })
    },
    removerContatoHandler(contatoRealizado) {
      this.$confirm('Deseja realmente remover este contato com o cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerContato(contatoRealizado);
      }).catch(() => {});
    },
    removerContato(contatoRealizado) {
      this.showLoading();
      this.removerContatoRealizado(contatoRealizado)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.contatoSelecionado = {};
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
    },
    exibirGravarContatoRealizadoDialog() {
      this.visibilidadeGravarContatoRealizadoDialog = true
    },
    fecharGravarContatoRealizadoDialog() {
      this.visibilidadeGravarContatoRealizadoDialog = false;
    },
    exibirEditarContatoRealizadoDialog(contato) {
      this.contatoRealizado = Object.assign({}, contato);
      this.contatoRealizado.dataProximoContato = contato.dataProximoContato;
      this.contatoRealizado.status = contato.status;
      this.dataProximoContato = contato.dataProximoContato.split(" ")[0];
      this.horaProximoContato = contato.dataProximoContato.split(" ")[1];
      this.visibilidadeEditarContatoRealizadoDialog = true;
    },
    fecharEditarContatoRealizadoDialog() {
      this.visibilidadeEditarContatoRealizadoDialog = false;
    },
    //CONTAS
    removerContaBancariaHandler(conta) {
      this.$confirm('Deseja realmente remover esta conta bancária do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerContaBancaria(conta);
      }).catch(() => {});
    },
    removerContaBancaria(conta) {
      this.showLoading();
      this.removerConta(conta)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })        
    },
    exibirGravarContaDialog() {
      this.visibilidadeGravarContaDialog = true
    },
    fecharGravarContaDialog() {
      this.visibilidadeGravarContaDialog = false;
    },
    exibirEditarContaDialog(conta) {
      this.contaBancaria = Object.assign({}, conta);
      this.visibilidadeEditarContaDialog = true;
    },
    fecharEditarContaDialog() {
      this.visibilidadeEditarContaDialog = false;
    },
    //OBSERVAÇÕES
    removerObservacaoHandler(observacao) {
      this.$confirm('Deseja realmente remover esta observação do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let payload = { id: observacao.id }        
        this.showLoading();
        this.removerObservacao(payload)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.observacaoSelecionada = {}
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
      })
    },
    exibirGravarObservacaoDialog() { 
      this.visibilidadeGravarObservacaoDialog = true; 
    },
    fecharGravarObservacaoDialog() { 
      this.visibilidadeGravarObservacaoDialog = false; 
    },
    exibirObservacao(observacaoSelecionada) { 
      this.observacaoSelecionada = observacaoSelecionada 
    },
    exibirColunaRemoverObservacao() {
      return (
        this.permissoes.removerObservacoes
      );
    },      
    //ARQUIVOS
    removerArquivoHandler(arquivo) {
       this.$confirm('Deseja realmente remover este arquivo do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let payload = { id: arquivo.id };
        this.showLoading();
        this.removerArquivo(payload)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERROR":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
      })
    },
    downloadArquivoHandler(arquivo) {
      window.open(arquivo.path, "_blank");
    },
    exibirDialogUploadArquivo() { 
      this.visibilidadeUploadArquivoDialog = true 
    },
    fecharDialogUploadArquivo() { 
      this.visibilidadeUploadArquivoDialog = false; 
    },
    //VISITAS
    removerVisitaHandler(visita) {
      this.$confirm('Deseja realmente remover esta visita do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerVisitaCliente(visita);
      }).catch(() => {});
    },
    removerVisitaCliente(visita){
      this.showLoading();
      this.removerVisita(visita)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;            
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
    },
    exibirGravarVisitaDialog() {
      this.visibilidadeGravarVisitaDialog = true
    },
    fecharGravarVisitaDialog() {
      this.visibilidadeGravarVisitaDialog = false;
    },
    exibirEditarVisitaDialog(visita) {
      this.visita = Object.assign({}, visita);
      this.dataVisita = visita.dataHora.split(" ")[0];
      this.horaVisita = visita.dataHora.split(" ")[1];
      let payload = { id: visita.id }
      this.recuperarVisita(payload)
      .then((resultado) => {
        if(resultado.status == "SUCESSO") {
          this.imoveisVisita = resultado.item;
          this.visibilidadeEditarVisitaDialog = true
        }
      });
    },
    fecharEditarVisitaDialog() {
      this.visibilidadeEditarVisitaDialog = false;
    },
    formatarString(str) {
      str = str.split('_');
      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
      }
      return str.join(" ");         
    },
    limparPesquisa() {
      this.limparClientePesquisa();
    },
    limparContato() {
      this.contatoSelecionado = {};
      this.contatoRealizado = {};
    },    
    enviar() {
      if(this.dadosPesquisaCliente){
        this.pesquisar();
      }
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    }
  }
}
